<template>
    <div>
        <div class="modal-header">
            <h2 class="text-center">Vil du slette noten?</h2>
        </div>

        <h6 class="text-center" style="font-style: italic;">Noten kan ikke genskabes</h6>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="deleteComment()">Ja</button>
                <button type="button" class="button-red" @click="closeModal()">Nej</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'history-modal-delete-comment',
    data () {
        return {
        }
    },
    props: {
        data: Object
    },
    methods: {
        deleteComment () {
            this.$emit('resendData', this.data)
        },
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/history/history-modal-delete-comment.vue